import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  { q: "How do I know a part fits my vehicle?", a: "Use our Vehicle Finder or Search by Part Number. Each listing shows the compatible years, makes, and engine sizes we have on record. If you're uncertain, submit the Fitment Assistance form and our team will verify with your VIN." },
  { q: "What's the difference between OEM, remanufactured, and used?", a: "OEM parts are original from the vehicle manufacturer. Remanufactured parts are used cores that have been cleaned, tested, and rebuilt. Used parts are pulled from working assemblies and inspected. Every listing labels the condition." },
  { q: "How long does shipping take?", a: "Standard nationwide shipping is 5–7 business days via USPS or UPS. Tracking information is emailed at fulfillment." },
  { q: "Do you offer free shipping?", a: "Yes — orders over $150 ship free within the continental United States. Below $150, standard shipping is a flat $12." },
  { q: "What is the return policy?", a: "30-day returns are accepted. Buyer is responsible for return shipping unless the item was not as described. See our Return Policy for the full details." },
  { q: "Do the products come with a warranty?", a: "Warranty terms vary by product and are listed on the product page. Many products carry a lifetime warranty from the manufacturer." },
  { q: "Can I buy directly on eBay instead?", a: "Yes — every product on our site links to the exact corresponding eBay listing so you can buy via the marketplace if you prefer." },
  { q: "Do you offer wholesale pricing?", a: "Yes. Qualified commercial buyers (mechanics, dealerships, fleets, resellers) can submit a wholesale application for review." },
];

export default function FAQ() {
  return (
    <div data-testid="faq-page" className="bg-slate-50 min-h-screen">
      <div className="max-w-3xl mx-auto px-4 lg:px-8 py-16">
        <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#0055FF]">Support</div>
        <h1 className="mt-2 font-display text-3xl lg:text-5xl font-extrabold text-slate-900 tracking-tight">Frequently asked questions</h1>
        <div className="mt-8 rounded-2xl border border-slate-200 bg-white">
          <Accordion type="single" collapsible className="divide-y divide-slate-100">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`f-${i}`} className="px-6">
                <AccordionTrigger className="text-left font-heading text-slate-900">{f.q}</AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  );
}
